<template>
  <div id="trend-data-input-period">
    <div class="title-area">
      <div class="sdf-text-20-400-white">データ期間</div>
    </div>
    <div id="input-container">
      <div class="date-picker-container sdf-text-18-400-white">
        
        <datepicker
          name="selectTargetDateFrom"
          class="date-picker"
          :language="ja"
          :format="formatter"
          :disabled-dates="fromDisabled"
          input-class="date-picker-inner"
          v-model="targetDateFrom"
          @selected="fromDateSelected"
        ></datepicker>
        <span class="arrow"></span>
        <span class="spacer">-</span>
        <datepicker
          name="selectTargetDateTo"
          class="date-picker"
          :language="ja"
          :format="formatter"
          :disabled-dates="toDisabled"
          input-class="date-picker-inner"
          v-model="targetDateTo"
          @selected="toDateSelected"
        ></datepicker>
        <span class="arrow"></span>
      </div>
      <div>
        <vs-dropdown vs-trigger-click class="dropdown" v-if="getOptionVersionIds.length > 1" v-model="selectedVersion">
          <a class="a-icon" href="#">
            <span v-if="getSelectedVersionId">{{getSelectedVersionId}}</span>
            <span v-else>バージョンを選択</span>
          </a>
          <vs-dropdown-menu  class="sdf-pagination-dropdown-menu">
            <vs-dropdown-item v-for="(id, index) in getOptionVersionIds" :key="index">
              <span @click="selectVersion(id)">{{id}}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <span class="arrow"></span>
      </div>
      <vs-button
        @click="searchTrendData"
        class="get-data-button"
        color="#2D9CDB"
        :disabled="!getSelectedVersionId"
      ><span class="sdf-text-18-400-white">データを取得</span></vs-button>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin"
import {createNamespacedHelpers} from "vuex"
import DatepickerMixin from "@/mixins/DatepickerMixin"
import Datepicker from "vuejs-datepicker"

const { mapGetters, mapActions } = createNamespacedHelpers("checklistTrendDataReport")

export default {
  name: "trendDataInputPeriod",
  mixins: [DatepickerMixin, SecureDataflowMixin],
  components: {
    Datepicker,
  },
  data: function () {
    return {
      date: null,
      targetDateFrom: null,
      targetDateTo: null,
      selectedVersion: null,
    }
  },
  computed: {
    ...mapGetters(["getChannelTimeFrom", "getChannelTimeTo", "getOptionVersionIds", "getSelectedVersionId", "getRooms"]),
    fromDisabled: function () {
      return {
        from: this.targetDateTo
      }
    },
    toDisabled: function () {
      return {
        to: this.targetDateFrom
      }
    }
  },
  async created() {
    if (this.getChannelTimeFrom && this.getChannelTimeTo) {
      this.targetDateFrom = moment(this.getChannelTimeFrom).toDate();
      this.targetDateTo   = moment(this.getChannelTimeTo).toDate();
    } else {
      this.targetDateFrom = moment().subtract(1, 'days').startOf('month').toDate();
      this.targetDateTo   = moment().subtract(1, 'days').toDate();
    }
    await this.setChannelTimeFromState(moment(moment(this.targetDateFrom).format("YYYY-MM-DDT00:00:00")).utc().toISOString());
    await this.setChannelTimeToState(moment(moment(this.targetDateTo).format("YYYY-MM-DDT23:59:59")).utc().toISOString());

    await this.setOptionVersionIdsState({});
    if ( this.getOptionVersionIds.length > 0 ) {
      // 得られたバージョン情報から、デフォルトバージョンをセットする。
      await this.setSelectedVersionIdState(this.getOptionVersionIds[this.getOptionVersionIds.length -1]);
    }

    await this.searchTrendData();
  },
  methods: {
    ...mapActions([
      "setChannelTimeFromState",
      "setChannelTimeToState",
      "setLastChannelTimeFromState",
      "setLastChannelTimeToState",
      "setTrendData",
      "setOptionVersionIdsState",
      "setSelectedVersionIdState",
      "setSelectedRoomId",
    ]),
    fromDateSelected: async function (newDate) {
      await this.setChannelTimeFromState(moment(moment(newDate).format("YYYY-MM-DDT00:00:00")).utc().toISOString())
      if (this.targetDateFrom != null && this.targetDateTo != null) {
        // call version API
        this.setOptionVersionIdsState({})
      }
    },
    toDateSelected: async function (newDate) {
      await this.setChannelTimeToState(moment(moment(newDate).format("YYYY-MM-DDT23:59:59")).utc().toISOString())   
      if (this.targetDateFrom != null && this.targetDateTo != null) {
        // call version API 
        this.setOptionVersionIdsState({})
      }
    },
    searchTrendData: async function () {
      this.openLoading()
      await this.setLastChannelTimeFromState(this.getChannelTimeFrom)
      await this.setLastChannelTimeToState(this.getChannelTimeTo)
      await this.setTrendData()

      const selectedRoomId = ( this.getRooms.m0_rooms && this.getRooms.m0_rooms.length > 0 ) ? this.getRooms.m0_rooms[0].room_id : "1";
      this.setSelectedRoomId(selectedRoomId);
    },
    openLoading(){
      this.$vs.loading({
        text: "データ取得中",
        textAfter: true,
        color: this.sdfColor.Blue,
        container: '#content-area',
      })
      setTimeout( ()=> {
        this.$vs.loading.close('#content-area > .con-vs-loading')
      }, 2000);
    },
    selectVersion(id) {
      this.setSelectedVersionIdState(id)
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";
.title-loading {
  color: $sdf-white;
  font-size: 30px;
}

#trend-data-input-period {
  background-color: $sdf-blue-black;
  padding: 30px;
  color: $sdf-white;
  display: flex;
  flex-direction: row;
  
  .spacer {
    margin: 0px 8px
  }

  .title-area {
    min-width: 220px;
  }

  #input-container {
    width: 100%;
    display: flex;

    .get-data-button {
      color: $sdf-blue;
    }
  }

  .master-container {
    height: 150px;
  }

  .calendar-icon {
    position: absolute;
    margin-top: 4px;
  }

  .vs-button {
    height: 37px;
  }

  .vs-button--text {
    display: flex !important;
  }

  .date-picker-container {
    display: inline;
  }
  
  .arrow{
    z-index: 2;
    border-color: $sdf-navy;
    border-style: solid;
    border-width: 10px;
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    margin-left: -30px;
    margin-bottom: 10px;
    position: absolute;
    margin-top: 13px;
    pointer-events: none;
  }

  .date-picker {
    width: 150px;
    display: inline-block;
  }

  .date-picker-inner {
    padding: 6px;
    padding-left: 16px;
  }

  .date-picker input {
    border: 2px solid $sdf-navy;
    background: transparent;
    color: $sdf-white;
    margin-bottom: 10px;
    font-size:18px;
  }

  .vdp-datepicker__calendar {
    background: $sdf-navy;
    border: transparent;

    .prev:hover, .up:hover, .next:hover {
      background: $sdf-blue !important;
    }

    .cell:hover {
      background: $sdf-blue !important;
    }

    .disabled {
      color: $sdf-light-navy;
    }

    .selected{
      background: $sdf-blue !important;

    }
  }

  .vs-button {
    padding: 4px 18px !important;
    font-size: 18px;
    margin-left: 20px;
  }

  .dropdown {
    text-align: left;
    min-height: 37px;
    max-height: 37px;
    width: 200px;
    border: 2px solid $sdf-navy;
    border-radius: 4px;
    padding-left: 14px;
    font-size: 18px;
    margin-left: 20px;
    p {
      color: $sdf-light-navy;
    }
    a {
      color: $sdf-white !important;
      
    }
  }
}

.sdf-pagination-dropdown-menu {
  .vs-dropdown--menu {
    border: 2px solid $sdf-navy;
    color: $sdf-white;
    background: $sdf-dark-blue-navy;
    font-size: 18px;
  }
  .vs-dropdown--menu--after {
    border-top: 2px solid $sdf-navy;
    border-left: 2px solid $sdf-navy;
    background: $sdf-dark-blue-navy;
    z-index: 300;
  }
}
</style>
